/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* CommunicationEvents service.
* @module api/CommunicationEventsApi
* @version v0.3
*/
export default class CommunicationEventsApi {

    /**
    * Constructs a new CommunicationEventsApi.
    * @alias module:api/CommunicationEventsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the communicationEventsGet operation.
     * @callback moduleapi/CommunicationEventsApi~communicationEventsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List communication events
     * @param {Object} opts Optional parameters
     * @param {String} opts.userId Patient or referred patient ID, or all for paginated outreach events
     * @param {Number} opts.page Page number (default to <.>)
     * @param {Number} opts.size Page size (default to <.>)
     * @param {Array.<module:model/String>} opts.sortBy Sort results
     * @param {String} opts.search Search records against patient name, email, phone number, and event name
     * @param {module:api/CommunicationEventsApi~communicationEventsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    communicationEventsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {

      };
      let queryParams = {
        'user_id': opts['userId'],'page': opts['page'],'size': opts['size'],'sort_by': this.apiClient.buildCollectionParam(opts['sortBy'], 'csv'),'search': opts['search']
      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/communication_events', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}